'use strict';

const $ = require('jquery');
const Slide = require('./slide');
const lang = require('../lang');
const Modal = require('../modal');
const template = require('../templates/track-slide.hbs');
const { isNull } = require('lodash');

function formatTime24Hour(date) {
  const hours = date.getHours();
  let minutes = date.getMinutes();
  minutes = minutes < 10 ? '0'+minutes : minutes;
  return hours + ':' + minutes;
}

module.exports = class extends Slide {
  constructor(context = {}) {
    context = $.extend({}, { title: lang.get('track_title') }, context);
    super(template, context);

    this._tracks = context.tracks;
    //noinspection JSUnresolvedVariable
    _idletimer = _mainidletimer;
    this.domEvents = {
      'click [data-track-id]': '_selectTrack',
      //'mousemove': '_resetIdleTimer',
      'keydown': '_resetIdleTimer',
      'click': '_resetIdleTimer'
    };

    this.on('beforeEnter', this._setChoiceListClass);
    this.on('afterEnter', this._stopIdleTimer);
    this.on('afterEnter', this._countdown);
  }

  // DOM EVENTS

  _selectTrack(e) {
    e.preventDefault();

    const trackId = parseInt($(e.currentTarget).data('track-id'), 10);
    const locCloseName = $(e.currentTarget).data('location-name');

    $.ajax({
      type: "POST",
      async: "true",
      url: '/getlocationcloseData',
      data:
      {
        locationId: trackId,
        time: formatTime24Hour(new Date()),
      },
      success: (result) => {
        if (result !== '' && typeof result !== undefined) {
          if (result['checkin_not_allowed'] === 'true') {
            new Modal({
              titleText: "",
              bodyText: lang.get('no_checkin_contact_recipient').replace(":location", locCloseName),
              submitBtnText: lang.get('form_modal_button')
            });
            return false;
          }
          if (!isNull(result['date']) && result['date'] !== "false") {
            const dateAndMonth = result['date'].split('-');
            const time = result['time'] ?? "";
            let message = lang.get('location_close');
            if (typeof dateAndMonth['2'] != "undefined") {
              let month = this._slideshow.getMonthName(dateAndMonth['1']);
              message = message.replace(":location", locCloseName).replace(":DD", dateAndMonth['2']).replace(":MMM", month).replace(":HHMM", time);
            } else {
              message = message.replace(":location", locCloseName).replace(":DD", time).replace(":MMM,", '').replace(":HHMM", '');
            }
            new Modal({
              titleText: lang.get('pul_modal_button'),
              bodyText: message,
              submitBtnText: lang.get('form_modal_button')
            });
            return false;
          }
          const track = this._tracks.find((track) => track.track_location_id === trackId);
          this._slideshow.setTrack(track);
          clearInterval(_idleintervalHandler);
          //noinspection JSUnresolvedVariable
          _idletimer = _mainidletimer;
          this._slideshow.navNext();
        }
      }
    });
    return false;
  }

  // SLIDE EVENTS

  _setChoiceListClass() {
    $("#label_exist_code").val('0');
    const $choiceList = $('.choice-list');
    $choiceList.removeClass('choice-list--two-columns choice-list--three-columns');
    if (this._tracks.length > 8)
      $choiceList.addClass('choice-list--three-columns');
    else if (this._tracks.length > 4)
      $choiceList.addClass('choice-list--two-columns');
  }

  _resetIdleTimer() {
    $('.idle-timer-container').hide();
    //noinspection JSUnresolvedVariable
    _idletimer = _mainidletimer;
  }
  _countdown() {
    //noinspection JSUnresolvedVariable
    _idletimer = _mainidletimer;
    $('.idle-timer-container').hide();
    const $domTimer = this.$el.find('#idle-timer');
    //noinspection JSUnresolvedVariable
    _idleintervalHandler = setInterval(() => {
      //noinspection JSUnresolvedVariable
      _idletimer -= 1;
      if (_idletimer <= 30) {
        $('.idle-timer-container').show();
        $domTimer.html(_idletimer);
      }
      if (_idletimer === 0) {
        this._slideshow._clearForm();
        $('#modal').modal('hide');
        clearInterval(_idleintervalHandler);
        //noinspection JSUnresolvedVariable
        _idletimer = _mainidletimer;
        $('.idle-timer-container').hide();
        window.location.hash = '/';
      }
    }, 1000);
  }

  _stopIdleTimer() {
    if (_idleintervalHandler !== undefined) {
      clearInterval(_idleintervalHandler);
    }
  }
};
